export const notificationsStoreKey = 'notifications';
